import { useAuthStore } from '../stores/authStore';
import { createAxiosHttpClient } from './AxiosHttpClient';
import { isUserTokenValid } from '@/features/auth/utils/authenticated-user.utils';

const httpClient = createAxiosHttpClient();

// Función para obtener el token de forma segura
const getAuthToken = (): string | null => {
  try {
    const state = useAuthStore.getState();

    // Verificar si el store ya se hidrato
    if (!state.hasHydrated) {
      console.warn('Auth store not hydrated yet, no token available');
      return null;
    }

    const { user } = state;

    if (!user) {
      return null;
    }

    // Validar que el token siga siendo válido
    if (!isUserTokenValid(user)) {
      console.warn('Token expired, triggering logout');
      // Disparar logout de forma asíncrona para no afectar el flujo actual
      setTimeout(() => {
        state.logout();
      }, 0);
      return null;
    }

    const token = user.accessToken;

    if (process.env.NODE_ENV === 'development') {
      console.log('Token retrieved for HTTP request:', token ? 'Present' : 'Not found');
    }

    return token || null;
  } catch (error) {
    console.error('Error getting auth token:', error);
    return null;
  }
};

// Configuramos tokenProvider global
httpClient.setTokenProvider(getAuthToken);

// Función para reconfigurar el cliente cuando sea necesario
export const reconfigureHttpClient = () => {
  httpClient.setTokenProvider(getAuthToken);
};

// Función para forzar la actualización del token en el próximo request
export const invalidateHttpClientToken = () => {
  // Si tu AxiosHttpClient tiene un método para limpiar el token cacheado
  // if (typeof httpClient.clearCachedToken === 'function') {
  //   httpClient.clearCachedToken();
  // }
};

export default httpClient;
